<template>
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">订单详情</h1>
    </nav>
    <div class="content">
      <div class="buttons-tab">
        <a href="#tab1" class="tab-link active button">全部</a>
        <a href="#tab2" class="tab-link button">待支付</a>
        <a href="#tab3" class="tab-link button">待发货</a>
      </div>

      <!-- this is the content of tabs-->
      <div class="tabs">
        <div id="tab1" class="tab active">
          <div class="content-block">
            <p>This is tab 1 content</p>
          </div>
          <div v-for="(product, index) in products" class="card demo-card-header-pic">
            <div class="card-header color-white no-border">订单{{index + 1}}</div>
            <div class="card-content">
              <div class="card-content-inner">
                <p class="color-gray">@2015/01/15</p>
                <div class="row">
                  <div class="col-20">
                    <img src="/emktResources/resocurces/img/gene.jpg" width="100%">
                  </div>
                  <div style="height: auto;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;" class="col-80">{{product.ProductName}}</div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <a href="#" class="link">再次购买</a>
              <router-link class="item-link" :to="{ name: 'orderDetail' }">订单详情</router-link>
            </div>
        </div>
        </div>
        <div id="tab2" class="tab">
          <div class="content-block">
            <p>This is tab 2 content</p>
          </div>
        </div>
        <div id="tab3" class="tab">
          <div class="content-block">
            <p>This is tab 3 content</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    mounted () {
      // console.log('mounted')
    },
    created () {
// 组件创建完后获取数据，
// 此时 data 已经被 observed 了
      this.fetchData()
    },
    data () {
      return {
        products: []
      }
    },
    watch: {
// 如果路由有变化，会再次执行该方法
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {

      }
    }
  }
</script>



// WEBPACK FOOTER //
// Orders.vue?f7e68026